import { postCall, getCall } from "./api";

// create a regularization / shift-change request
export const createAttendanceRequest = async (input = {}) => {
  return await postCall({ path: `/attendance-request`, bodyParams: input, });
};

// All requests for the org (admin). Accepts either a bare type string (the
// original call shape, still used by the requests listing) or a params object:
//   { type, employeeId, source, dayString }
// The employee filter is what lets a single register pull just its own
// corrections instead of the whole org's.
export const getAllAttendanceRequests = async (params) => {
  const query = typeof params === "string" ? { type: params } : params || {};
  const search = new URLSearchParams(
    Object.entries(query).filter(([, v]) => v !== undefined && v !== null && v !== "")
  ).toString();
  return await getCall({ path: `/attendance-request${search ? `?${search}` : ""}`, });
};

// requests raised by the logged-in employee, optional type filter
export const getSelfAttendanceRequests = async (type) => {
  return await getCall({ path: `/attendance-request/self${type ? `?type=${type}` : ""}`, });
};

export const getAttendanceRequestById = async (id) => {
  return await getCall({ path: `/attendance-request/${id}`, });
};

// Attest one correction across many employees on a single day.
//   { dayString, reason, source, updatedClockInTime, updatedClockOutTime, employeeIds }
// Resolves with { applied, failed, results } — per-employee outcomes, because a
// partial failure is the normal case and the caller has to be able to say which.
export const createBulkAttendanceRequests = async (input = {}) => {
  return await postCall({ path: `/attendance-request/bulk`, bodyParams: input, });
};

// approve / reject  { status: "Approved" | "Rejected", reviewerComment }
export const reviewAttendanceRequest = async (id, input = {}) => {
  return await postCall({ path: `/attendance-request/${id}/review`, bodyParams: input, });
};

// corrections raised by the caller's direct reports
export const getTeamAttendanceRequests = async (status) =>
  await getCall({ path: `/attendance-request/team${status ? `?status=${status}` : ""}` });
